import { useMutation } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useUpdateNotes = () => {
  const mutation = useMutation((formData) => {
    return axiosClient.put("/DocumentType/UpdateDocumentNotes", formData);
  });
  return mutation;
};
export default useUpdateNotes;
